import React, { useEffect, useRef, useState } from 'react'
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import Typography from '@mui/material/Typography';
import { PDF_example } from './Base64';
import { Divider, Grid, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ErroPagerPDF from "./ErroPagerPDF";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';


interface ModalPreviewPDFProps {
    openPDF: boolean;
    setOpenPDF: (value: boolean) => void;
    setBase64PDF: (value: string) => void;
    base64PDF: string;
}


const ModalPreviewPDF: React.FC<ModalPreviewPDFProps> = ({ setOpenPDF,setBase64PDF, openPDF,base64PDF }) => {
    // const [open, setOpen] = useState<boolean>(false);
    // const handleClose = (): void => setOpenPDF(false);
      const [scale, setScale] = useState<number>(0.6);
      const [scaleForReset, setScaleForReset] = useState<number>(0.6);
      const [errorPDF, setErrorPDF] = useState<string>('')
      const [pageNumber, setPageNumber] = useState<number>(1);
      const [totalPage, setTotalPage] = useState<number>(1);
      const viewerRef = useRef(null)


  const HoverIconButton = styled(IconButton)({
    backgroundColor: 'transparent',
    borderRadius: 3,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      // Change background on hover
    }
  });


  const onLoadProgress = () => {
    const container: any = viewerRef.current
    if (container) {
      const handleResize = () => {
        const newScale = container.clientWidth / 1312; // 612 is the default width of the page in points
        setScale(newScale);
        setScaleForReset(newScale)
      };
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }
  
  const onDocumentLoadSuccess = (numPages: any) => {
    // console.log(numPages._pdfInfo.numPages)
    setErrorPDF('')
    setTotalPage(numPages._pdfInfo.numPages);
    setPageNumber(1)
    setScale(scaleForReset)
  }

  const onLoadError = (error: Error) => {
    console.error('Error while loading document:', error);
    setTotalPage(1);
    setPageNumber(1)
    setErrorPDF('There was an error loading the PDF document.');
  }

    const handleClose = () => {
        setOpenPDF(false);
        setBase64PDF('')
    }
          
    return (
        <div>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={openPDF}
                    onClose={handleClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                        backdrop: {
                            timeout: 500,
                        },
                    }}
                >
                    <Fade in={openPDF}>
                        <Box
                            ref={viewerRef}
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "70vw", // Responsive width
                                height: "90vh", // Full-screen height
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                borderRadius: 2,
                                p: 2,
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <Grid container direction={'row'} justifyContent={'space-between'}>
                                {/* <Grid item>
                                    <Typography id="transition-modal-title" variant="h6" component="h2">
                                        PDF Preview
                                    </Typography>
                                </Grid> */}

                                <Grid xs item display={'flex'} justifyContent={'flex-end'}> 
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </Grid>

                            </Grid>
                            {/* <Divider /> */}
                            <Box
                    style={{ overflow: 'auto', width: '100%', height: '100vh', backgroundColor: '#FFFFFF',display: "flex", justifyContent: "center" }}
                  >
                  {errorPDF ? <ErroPagerPDF/> :     
                    <Document file={`${base64PDF}`} onLoadProgress={onLoadProgress} onLoadSuccess={onDocumentLoadSuccess} onLoadError={onLoadError}>
                      <Page width={window.screen.width > 1000 ? 1000 : window.screen.width - 20} pageNumber={pageNumber} scale={scale}/>
                    </Document>}
                
                  </Box>
                   <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Grid container
                      xs="auto"
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#323639',
                        padding: 0.5,
                        borderRadius: 2,
                        mt: 2,
                        gap: 1
                      }}>
                      <Grid item>
                        <HoverIconButton aria-label="delete" sx={{ color: '#ffffff' }} size="medium" onClick={() => pageNumber > 1 ? setPageNumber(pageNumber - 1) : setPageNumber(1)}>
                          <ArrowBackIosIcon fontSize="small" /></HoverIconButton>
                      </Grid>
                      <Grid item>
                        <Typography sx={{ color: '#ffffff' }}>{pageNumber}/{totalPage}</Typography>
                      </Grid>

                      <Grid item>
                        <HoverIconButton aria-label="delete" sx={{ color: '#ffffff' }} size="medium" onClick={() => pageNumber < totalPage ? setPageNumber(pageNumber + 1) : setPageNumber(totalPage)}>
                          <ArrowForwardIosIcon fontSize="small" /></HoverIconButton>
                      </Grid>
                      <Grid item>
                        <Divider sx={{ color: '#ffffff', borderColor: "#ffffff", borderWidth: "1px", height: '30px' }}
                          orientation="vertical" flexItem />
                      </Grid>
                      <Grid item>
                        <HoverIconButton aria-label="zoom-in" size="medium">
                          <ZoomInIcon fontSize="medium" sx={{ color: '#ffffff' }} onClick={() => setScale((prevScale: number) => prevScale + 0.2)} />
                        </HoverIconButton>
                        <HoverIconButton aria-label="delete" size="medium">
                          <ZoomOutIcon fontSize="medium" sx={{ color: '#ffffff' }} onClick={() => setScale((prevScale: number) => Math.max(prevScale - 0.2, 0.5))} />
                        </HoverIconButton>
                      </Grid>

                    </Grid>

                    {/* <button onClick={() => setScale((prevScale: number) => prevScale + 0.2)}><ZoomInIcon /></button> */}
                    {/* <button onClick={() => setScale((prevScale: number) => Math.max(prevScale - 0.2, 0.5))}>Zoom Out</button> */}
                    {/* <button onClick={() => setScale(0.6)}>Reset</button> */}

                  </Grid>
                            {/* Ensure Full Height for PDF */}
                            {/* <Box sx={{ width: "100%", flexGrow: 1, bgcolor: "#ffffff", overflow: "hidden", mt: 2 }}>
                                <iframe
                                    src={`data:application/pdf;base64,${base64PDF}`}
                                    width="100%"
                                    height="100%"
                                    style={{ border: "none", display: "block", flexGrow: 1 }}
                                />
                            </Box> */}
                        </Box>
                    </Fade>
                </Modal>
            </div>
        </div>
    )
}

export default ModalPreviewPDF
